import script from "./Group2Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Group2Popup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__